<template>
    <Button
        @click="$emit('click')"
        :disabled="disabled"
        size="sm"
    >
        {{ $t('Component(Button):done-goto-next-step') }}
    </Button>
</template>

<script>
import {Button} from "@core/components/common";

export default {
    components: {Button},
    props: {disabled: {default: false}}
}
</script>
